import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface TogglePillOption {
  value: any;
  label: string;
}

@Component({
  selector: 'app-br-toggle-pills',
  templateUrl: './toggle-pills.component.html'
})
export class BrTogglePillsComponent {
  @Input() options: TogglePillOption[] = [];
  @Input() value: any;
  @Input() note: string;
  @Output() valueChange = new EventEmitter<any>();

  select(option: TogglePillOption) {
    this.valueChange.emit(option.value);
  }
}
